import React from "react";
import istanbulHero from "../../assets/turkey/istanbul-hero.jpg";
import cappadociaHero from "../../assets/turkey/cappadocia-hero.jpg";
import bodrumHero from "../../assets/turkey/bodrum-hero.jpg";
import pattern from "../../assets/turkey/pattern.jpg";

type Stop = { time: string; title: string; note?: string; cost?: string; tag?: string };
type Day = { date: string; label: string; title: string; stops: Stop[]; total?: string };
type City = {
  id: string;
  name: string;
  dates: string;
  tagline: string;
  hero: string;
  hotel: { name: string; url: string; confirmation: string; perks: string };
  flight: { route: string; flight: string; times: string; confirmation: string };
  returnFlight?: { route: string; flight: string; times: string; confirmation: string };
  days: Day[];
};

const cities: City[] = [
  {
    id: "istanbul",
    name: "İstanbul",
    dates: "Jun 5 – Jun 8",
    tagline: "Where two continents whisper to each other across the Bosphorus.",
    hero: istanbulHero,
    hotel: {
      name: "Sura Hagia Sophia Hotel",
      url: "https://surahotels.com/sura-hagia-sophia-hotel",
      confirmation: "12570424",
      perks: "Breakfast included • Sultanahmet",
    },
    flight: {
      route: "YYZ → IST",
      flight: "TS214 • NVUBSY",
      times: "Jun 4 · 9:00 PM → Jun 5 · 2:00 PM",
      confirmation: "NVUBSY",
    },
    days: [
      {
        date: "Jun 5",
        label: "Day 1",
        title: "Touchdown & Sultanahmet at sundown",
        total: "≈ 7,132 TL",
        stops: [
          { time: "2:30 PM", title: "Land at Istanbul Airport", tag: "Arrival" },
          { time: "3:00 PM", title: "HVIST-11 Havaist bus → hotel", cost: "760 TL", tag: "Transit" },
          { time: "7:00 PM", title: "Dinner · Tarihi Sultanahmet Köftecisi", cost: "1,600 TL", tag: "Eat" },
          { time: "8:00 PM", title: "Evening walk · Hagia Sophia, Blue Mosque & Sultanahmet Square", note: "Quiet, golden, romantic." },
          { time: "9:00 PM", title: "Queb Rooftop Restaurant", cost: "3,672 TL", tag: "Eat" },
          { time: "10:30 PM", title: "Dessert · Hafız Mustafa", cost: "1,100 TL", tag: "Sweet" },
          { time: "11:00 PM", title: "Back to the hotel" },
        ],
      },
      {
        date: "Jun 6",
        label: "Day 2",
        title: "Old City to Galata, by foot and funicular",
        total: "≈ 6,300 TL",
        stops: [
          { time: "7:00 AM", title: "Wake up" },
          { time: "8:00 AM", title: "Light breakfast at the hotel" },
          { time: "9:00 AM", title: "Blue Mosque" },
          { time: "9:45 AM", title: "Hagia Sophia" },
          { time: "10:00 AM", title: "Walk by Topkapı Palace" },
          { time: "10:30 AM", title: "Gülhane Park · sit on the grass" },
          { time: "11:30 AM", title: "Lunch · Şehzade Cağ Kebabı", cost: "1,000 TL", tag: "Eat" },
          { time: "12:15 PM", title: "Dessert · Tatlıcı Safa / Hafız Mustafa", cost: "1,000 TL", tag: "Sweet" },
          { time: "12:45 PM", title: "Snacks along Hoca Paşa street", cost: "1,000 TL" },
          { time: "1:30 PM", title: "Egyptian Bazaar" },
          { time: "2:30 PM", title: "Fish sandwich · Tarihi Eminönü Derya Balıkçısı", cost: "300 TL", note: "Optional." },
          { time: "3:00 PM", title: "Walk across Galata Bridge" },
          { time: "3:30 PM", title: "Galataport" },
          { time: "4:30 PM", title: "Kardeşler Cafe", cost: "1,000 TL" },
          { time: "5:00 PM", title: "Taksim Square" },
          { time: "6:00 PM", title: "Mornings in Pera", cost: "1,000 TL" },
          { time: "6:45 PM", title: "Funicular up to Galata Tower", tag: "Transit" },
          { time: "7:30 PM", title: "Göçmen Artisan Bakery · tea & sunset", cost: "500 TL" },
          { time: "8:45 PM", title: "Viyana Kahvesi · cheesecake & photos", cost: "500 TL" },
          { time: "9:30 PM", title: "Head back" },
          { time: "10:00 PM", title: "Wind down at the hotel" },
        ],
      },
      {
        date: "Jun 7",
        label: "Day 3",
        title: "Grand Bazaar · Balat · Kadıköy by ferry",
        stops: [
          { time: "7:00 AM", title: "Wake up" },
          { time: "8:00 AM", title: "Breakfast at the hotel" },
          { time: "9:30 AM", title: "Grand Bazaar" },
          { time: "11:00 AM", title: "Lunch · Nasip Et Kebap", cost: "1,500 TL", tag: "Eat" },
          { time: "12:00 PM", title: "Wander into Balat" },
          { time: "12:15 PM", title: "Coffee · Cafe Life 1890 or Iterrs", cost: "500 TL" },
          { time: "1:00 PM", title: "Colorful stairs & street wandering" },
          { time: "2:00 PM", title: "Merdivenli Yokuş Evleri photo spot" },
          { time: "2:30 PM", title: "Sweet stop · Helvacı Ali Balat", cost: "500 TL", tag: "Sweet" },
          { time: "3:00 PM", title: "Walk down toward Eminönü ferry terminal" },
          { time: "3:45 PM", title: "Ferry to Kadıköy", tag: "Transit" },
          { time: "5:00 PM", title: "Kadıköy market" },
          { time: "6:00 PM", title: "Borsam Taşfırın", cost: "1,000 TL", tag: "Eat" },
          { time: "6:45 PM", title: "Umbrella Street" },
          { time: "7:00 PM", title: "Pide Sun", cost: "500 TL" },
          { time: "7:45 PM", title: "Künefe · Asi Künefeleri Kadıköy", cost: "500 TL", tag: "Sweet" },
          { time: "8:49 PM", title: "Ferry back", tag: "Transit" },
          { time: "9:22 PM", title: "Connect to T1 at Bağcılar", tag: "Transit" },
          { time: "9:34 PM", title: "Back at the hotel" },
          { time: "11:00 PM", title: "Sleep" },
        ],
      },
      {
        date: "Jun 8",
        label: "Day 4",
        title: "Onward to Cappadocia",
        stops: [
          { time: "6:00 AM", title: "Wake up" },
          { time: "7:00 AM", title: "Breakfast" },
          { time: "8:00 AM", title: "Leave for the airport", tag: "Transit" },
          { time: "11:20 AM", title: "Flight to Nevşehir", tag: "Flight" },
        ],
      },
    ],
  },
  {
    id: "cappadocia",
    name: "Cappadocia",
    dates: "Jun 8 – Jun 11",
    tagline: "Fairy chimneys, sunrise balloons and lamp-lit nights.",
    hero: cappadociaHero,
    hotel: {
      name: "Henna Hotel",
      url: "https://www.hennacappadocia.com/en",
      confirmation: "989997886",
      perks: "Breakfast included • Göreme",
    },
    flight: {
      route: "IST → NAV",
      flight: "TS214 • T5G3MM",
      times: "Jun 8 · 11:20 AM → 12:40 PM",
      confirmation: "T5G3MM",
    },
    days: [
      {
        date: "Jun 8",
        label: "Day 1",
        title: "Settle into Göreme",
        stops: [
          { time: "12:40 PM", title: "Land at Nevşehir", tag: "Arrival" },
          { time: "2:00 PM", title: "Arrive at Henna Hotel" },
          { time: "2:15 PM", title: "Unpack & settle in" },
          { time: "3:00 PM", title: "Lunch · Göreme Han Restaurant", cost: "2,000 TL", tag: "Eat" },
          { time: "4:00 PM", title: "Galerie İkman" },
          { time: "4:30 PM", title: "Explore local shops" },
          { time: "7:30 PM", title: "Dinner · Seten Restaurant", cost: "3,000 TL", tag: "Eat" },
          { time: "9:00 PM", title: "Night terrace at the hotel" },
          { time: "10:00 PM", title: "Sleep" },
        ],
      },
      {
        date: "Jun 9",
        label: "Day 2",
        title: "Horseback dawn & lamp making",
        stops: [
          { time: "5:00 AM", title: "Horseback ride", cost: "4,000 TL", tag: "Experience" },
          { time: "7:30 AM", title: "Rest" },
          { time: "9:00 AM", title: "Breakfast at the hotel" },
          { time: "11:00 AM", title: "Göreme Open Air Museum" },
          { time: "1:00 PM", title: "Lunch · Testi Kebabı", cost: "2,000 TL", tag: "Eat" },
          { time: "3:00 PM", title: "Lamp making class", tag: "Experience" },
          { time: "5:15 PM", title: "Back to hotel · drop off lamps" },
          { time: "7:00 PM", title: "Dinner · Afara", cost: "3,000 TL", tag: "Eat" },
          { time: "8:30 PM", title: "Catch the sunset" },
          { time: "9:30 PM", title: "Back at the hotel" },
          { time: "10:30 PM", title: "Sleep" },
        ],
      },
      {
        date: "Jun 10",
        label: "Day 3",
        title: "Paşabağ, Uçhisar & an ATV sunset",
        stops: [
          { time: "8:00 AM", title: "Breakfast at the hotel" },
          { time: "10:15 AM", title: "Taxi to Paşabağ & walk", cost: "500 TL", tag: "Transit" },
          { time: "12:15 PM", title: "Zelve Open Air Museum" },
          { time: "1:15 PM", title: "Lunch near Paşabağ", cost: "1,500 TL", tag: "Eat" },
          { time: "2:15 PM", title: "Uçhisar Castle" },
          { time: "4:15 PM", title: "Back to the hotel" },
          { time: "5:00 PM", title: "ATV sunset ride", tag: "Experience" },
          { time: "7:00 PM", title: "Freshen up" },
          { time: "8:15 PM", title: "Dinner · Kebapzade Restaurant", cost: "3,000 TL", tag: "Eat" },
          { time: "9:45 PM", title: "Back to the hotel" },
          { time: "10:30 PM", title: "Sleep" },
        ],
      },
      {
        date: "Jun 11",
        label: "Day 4",
        title: "Balloon dawn & onward to Bodrum",
        stops: [
          { time: "4:30 AM", title: "Wake for balloon photos", tag: "Experience" },
          { time: "5:30 AM", title: "Breakfast" },
          { time: "8:30 AM", title: "Back to the hotel" },
          { time: "8:45 AM", title: "Pack" },
          { time: "9:45 AM", title: "Leave for the airport", tag: "Transit" },
        ],
      },
    ],
  },
  {
    id: "bodrum",
    name: "Bodrum",
    dates: "Jun 11 – Jun 14",
    tagline: "Aegean blue, all-inclusive ease, nothing to do but rest.",
    hero: bodrumHero,
    hotel: {
      name: "TUI Magic Life Bodrum",
      url: "https://www.magiclife.com/de/de/cluburlaub/tuerkei/bodrum/",
      confirmation: "844655904",
      perks: "All inclusive",
    },
    flight: {
      route: "NAV → BJV",
      flight: "RSGR8U",
      times: "Jun 11 · 1:25 PM → 5:40 PM",
      confirmation: "RSGR8U",
    },
    returnFlight: {
      route: "IST → YYZ",
      flight: "TS215 · NVUBSY",
      times: "Jun 14 · 3:45 PM → 7:45 PM",
      confirmation: "NVUBSY",
    },
    days: [
      {
        date: "Jun 11",
        label: "Day 1",
        title: "Arrive & dinner",
        stops: [{ time: "Evening", title: "Welcome dinner at the resort", tag: "Eat" }],
      },
      {
        date: "Jun 12",
        label: "Day 2",
        title: "Pool day",
        stops: [{ time: "All day", title: "Relax & pool" }],
      },
      {
        date: "Jun 13",
        label: "Day 3",
        title: "Pool, shops & Zuma",
        stops: [
          { time: "All day", title: "Relax & pool" },
          { time: "6:00 PM", title: "Designer shops" },
          { time: "8:00 PM", title: "Apps at Zuma", cost: "2,000 TL", tag: "Eat" },
        ],
      },
      {
        date: "Jun 14",
        label: "Day 4",
        title: "Fly home",
        stops: [
          { time: "4:00 AM", title: "Wake up" },
          { time: "5:00 AM", title: "Leave for the airport", tag: "Transit" },
          { time: "6:00 AM", title: "Arrive at BJV" },
          { time: "8:35 AM", title: "BJV → IST → Home", tag: "Flight" },
        ],
      },
    ],
  },
];

function Nav() {
  return (
    <nav className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-background/70 border-b border-border/60">
      <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
        <a href="#top" className="font-serif text-lg tracking-tight">
          Türkiye <span className="text-primary">·</span> Jun &apos;26
        </a>
        <div className="hidden sm:flex items-center gap-6 text-sm">
          {cities.map((c) => (
            <a key={c.id} href={`#${c.id}`} className="hover:text-primary transition-colors">
              {c.name}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}

function Hero() {
  return (
    <header id="top" className="relative h-[92vh] min-h-[560px] w-full overflow-hidden">
      <img
        src={istanbulHero}
        alt="Hagia Sophia at sunset over the Bosphorus"
        width={1920}
        height={1080}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-background" />
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 text-white">
        <p className="ornament uppercase tracking-[0.3em] text-xs sm:text-sm font-light text-white/90">
          June 4 — 14, 2026
        </p>
        <h1 className="mt-6 font-serif text-5xl sm:text-7xl md:text-8xl text-balance leading-[1.05]">
          A romantic passage<br />through <em className="text-[hsl(42_55%_72%)]">Türkiye</em>
        </h1>
        <p className="mt-6 max-w-xl text-base sm:text-lg text-white/85 text-balance">
          Ten days, three cities, one carefully threaded route — from Istanbul&apos;s
          minarets to Cappadocia&apos;s sky, ending on the Aegean.
        </p>
        <div className="mt-10 flex gap-3 text-xs sm:text-sm">
          {cities.map((c) => (
            <a
              key={c.id}
              href={`#${c.id}`}
              className="px-4 py-2 rounded-full border border-white/40 bg-white/10 backdrop-blur hover:bg-white/20 transition-colors"
            >
              {c.name}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
}

function Overview() {
  return (
    <section className="relative py-20 sm:py-28 bg-gradient-warm">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center">
          <p className="ornament uppercase tracking-[0.25em] text-xs text-primary">The Journey</p>
          <h2 className="mt-4 text-4xl sm:text-5xl">Three cities, one love letter</h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {cities.map((c, i) => (
            <a
              key={c.id}
              href={`#${c.id}`}
              className="group relative overflow-hidden rounded-xl shadow-card hover:shadow-soft transition-all duration-500"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={c.hero}
                  alt={c.name}
                  loading="lazy"
                  width={1200}
                  height={1500}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 text-white">
                <p className="text-xs tracking-[0.25em] uppercase opacity-80">Chapter {i + 1}</p>
                <h3 className="mt-2 text-3xl font-serif">{c.name}</h3>
                <p className="text-sm opacity-90 mt-1">{c.dates}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

function CityHero({ city, index }: { city: City; index: number }) {
  return (
    <div id={city.id} className="relative h-[60vh] min-h-[420px] overflow-hidden scroll-mt-14">
      <img
        src={city.hero}
        alt={city.name}
        loading="lazy"
        width={1920}
        height={1080}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background" />
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 text-white">
        <p className="uppercase tracking-[0.3em] text-xs opacity-80">Chapter {index + 1} · {city.dates}</p>
        <h2 className="mt-4 font-serif text-6xl sm:text-7xl">{city.name}</h2>
        <p className="mt-4 max-w-xl text-balance text-white/90 italic font-serif text-lg sm:text-xl">
          &ldquo;{city.tagline}&rdquo;
        </p>
      </div>
    </div>
  );
}

function InfoCard({ title, lines }: { title: string; lines: { k: string; v: React.ReactNode }[] }) {
  return (
    <div className="rounded-xl bg-card border border-border p-6 shadow-card">
      <p className="text-xs uppercase tracking-[0.2em] text-primary">{title}</p>
      <dl className="mt-4 space-y-2 text-sm">
        {lines.map((l) => (
          <div key={l.k} className="flex gap-3">
            <dt className="w-24 shrink-0 text-muted-foreground">{l.k}</dt>
            <dd className="text-foreground">{l.v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

const tagColor: Record<string, string> = {
  Eat: "bg-[hsl(38_45%_92%)] text-[hsl(18_45%_32%)]",
  Sweet: "bg-[hsl(340_40%_92%)] text-[hsl(340_45%_35%)]",
  Transit: "bg-[hsl(200_25%_91%)] text-[hsl(210_30%_30%)]",
  Flight: "bg-[hsl(220_30%_90%)] text-[hsl(230_35%_30%)]",
  Arrival: "bg-[hsl(140_30%_91%)] text-[hsl(150_35%_28%)]",
  Experience: "bg-[hsl(50_45%_91%)] text-[hsl(42_50%_32%)]",
};

function DayCard({ day }: { day: Day }) {
  return (
    <article className="rounded-2xl bg-card border border-border shadow-card overflow-hidden">
      <header className="px-6 py-5 border-b border-border bg-[hsl(38_25%_95%)] flex items-baseline justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-primary">{day.label} · {day.date}</p>
          <h3 className="mt-1 text-2xl font-serif text-balance">{day.title}</h3>
        </div>
        {day.total && (
          <span className="text-xs text-muted-foreground whitespace-nowrap">{day.total}</span>
        )}
      </header>
      <ol className="divide-y divide-border/70">
        {day.stops.map((s, i) => (
          <li key={i} className="flex gap-5 px-6 py-4 hover:bg-secondary/40 transition-colors">
            <div className="w-20 shrink-0 pt-0.5">
              <span className="text-sm font-medium text-foreground tabular-nums">{s.time}</span>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-2">
                <p className="text-[15px] text-foreground">{s.title}</p>
                {s.tag && (
                  <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full ${tagColor[s.tag] ?? "bg-muted text-muted-foreground"}`}>
                    {s.tag}
                  </span>
                )}
              </div>
              {s.note && <p className="text-sm text-muted-foreground italic mt-0.5">{s.note}</p>}
            </div>
            {s.cost && (
              <div className="text-xs text-muted-foreground tabular-nums whitespace-nowrap pt-1">
                {s.cost}
              </div>
            )}
          </li>
        ))}
      </ol>
    </article>
  );
}

function CitySection({ city, index }: { city: City; index: number }) {
  return (
    <section>
      <CityHero city={city} index={index} />
      <div className="max-w-5xl mx-auto px-6 -mt-20 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <InfoCard
            title="Hotel"
            lines={[
              {
                k: "Stay",
                v: (
                  <a className="text-primary hover:underline" href={city.hotel.url} target="_blank" rel="noreferrer">
                    {city.hotel.name}
                  </a>
                ),
              },
              { k: "Dates", v: city.dates },
              { k: "Perks", v: city.hotel.perks },
              { k: "Conf.", v: <span className="font-mono text-xs">{city.hotel.confirmation}</span> },
            ]}
          />
          <InfoCard
            title="Flight"
            lines={[
              { k: "Route", v: city.flight.route },
              { k: "Flight", v: city.flight.flight },
              { k: "Times", v: city.flight.times },
              { k: "Conf.", v: <span className="font-mono text-xs">{city.flight.confirmation}</span> },
            ]}
          />
          {city.returnFlight && (
            <div className="md:col-span-2">
              <InfoCard
                title="Return Flight Home"
                lines={[
                  { k: "Route", v: city.returnFlight.route },
                  { k: "Flight", v: city.returnFlight.flight },
                  { k: "Times", v: city.returnFlight.times },
                  { k: "Conf.", v: <span className="font-mono text-xs">{city.returnFlight.confirmation}</span> },
                ]}
              />
            </div>
          )}
        </div>

        <div className="mt-16 space-y-6 pb-24">
          {city.days.map((d) => (
            <DayCard key={d.date + d.label} day={d} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="relative border-t border-border bg-[hsl(38_22%_94%)]">
      <div
        aria-hidden
        className="h-3 w-full opacity-30"
        style={{ backgroundImage: `url(${pattern})`, backgroundSize: "60px" }}
      />
      <div className="max-w-5xl mx-auto px-6 py-12 text-center">
        <p className="ornament uppercase tracking-[0.25em] text-xs text-primary">Görüşürüz</p>
        <p className="mt-4 font-serif text-2xl">See you on the other side of the Bosphorus.</p>
        <p className="mt-2 text-sm text-muted-foreground">June 4 — 14, 2026</p>
      </div>
    </footer>
  );
}

const TurkeyIndex = () => {
  return (
    <main className="bg-background text-foreground">
      <Nav />
      <Hero />
      <Overview />
      {cities.map((c, i) => (
        <CitySection key={c.id} city={c} index={i} />
      ))}
      <Footer />
    </main>
  );
};

export default TurkeyIndex;
